"use client"

export const FasPurpose = () => {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12 animate-in fade-in duration-700">
          <div className="inline-flex items-center gap-2 bg-amber-50 text-amber-700 px-4 py-2 rounded-full text-sm mb-4 font-semibold shadow-sm">
            <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></span>
            Why We Exist
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Purpose
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            Creating lasting change through education and empowerment
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-xl p-6 sm:p-8 lg:p-10 border border-gray-100 animate-in slide-in-from-bottom duration-700" style={{ animationDelay: '200ms' }}>
          <div className="border-l-4 border-orange-500 pl-6 mb-8">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Bridging the Educational Gap</h3>
            <p className="text-xs sm:text-sm text-gray-600 uppercase tracking-wide">Our Mission & Vision</p>
          </div>
          <div className="space-y-5 sm:space-y-6">
            <p className="text-lg md:text-xl leading-relaxed text-gray-700 mb-6 text-justify">
              <span className="font-bold text-3xl float-left mr-0.5 leading-none text-orange-500">F</span>
              ly & Share is a non-profit organization dedicated to transforming education by providing essential
              learning tools and resources to students in need. Our mission is rooted in the belief that every student
              should have equal access to quality education and the necessary materials that empower them to succeed.
            </p>
            <p className="text-sm sm:text-base leading-relaxed text-gray-700">
              We strive to bridge the educational gap by supplying notebooks, stationery, digital devices, toiletries,
              and other educational resources to disadvantaged students across communities.
            </p>
            <p className="text-sm sm:text-base leading-relaxed text-gray-700">
              Our goal is to foster a conducive learning environment where students can thrive academically and realize
              their full potential.
            </p>
            <p className="text-sm sm:text-base leading-relaxed text-gray-700">
              Through strategic partnerships with schools, educational institutions, and local communities, we identify
              the specific needs of students and work diligently to fulfill those needs. We organize fundraising
              initiatives, donation drives, and collaborate with our friends to raise awareness about the importance of
              education and equitable access to learning tools.
            </p>
            <div className="bg-orange-50 border-l-4 border-orange-500 p-5 sm:p-6 rounded-r-lg">
              <p className="text-sm sm:text-base leading-relaxed text-gray-900 font-semibold">
                At Fly and Share, we envision a future where no student is hindered by lack of resources, and education
                becomes a powerful catalyst for positive change. By providing the tools for learning, we aspire to nurture
                a generation of knowledgeable, confident, and empowered individuals who will contribute to the betterment
                of society and inspire others to do the same.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
